export default __webpack_public_path__ + "static/media/kwid-colour-1.eec16b7b.jpg";